import { Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_677';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor de renta presuntiva  ', listHelp: ['677'] }
];

@Component({
  selector: 'app-descuentos-renta-presuntiva-modal',
  templateUrl: './descuentos-renta-presuntiva-modal.component.html',
  styleUrls: ['./descuentos-renta-presuntiva-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class DescuentosRentaPresuntivaModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<DescuentosRentaPresuntivaModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }


  protected inicializeModelo(){
    // if(this.model.doc.cuerpo.cs_id_674 == undefined)this.model.doc.cuerpo.cs_id_674=null;
    if(this.model.doc.cuerpo.cs_id_675 == undefined)this.model.doc.cuerpo.cs_id_675="0";
  }
  
  public operacionCs153():void {
    this.model.doc.cuerpo.cs_id_153 = this.model.doc.cuerpo.cs_id_153;
    this.model.doc.cuerpo.cs_id_154 = this.model.doc.cuerpo.cs_id_153;
  }
  
  
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 675: this.OperacionCs675(); break;
    }
  }

  OperacionCs675() {
    this.model.doc.cuerpo.cs_id_675=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_675,true);
    const cas675 = this.model.doc.cuerpo.cs_id_675
     if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas675,"0")) {
      this.dNotificacionServicio.mostrarDialogoInformacion("El valor de la renta presuntiva no puede ser cero");
      return
     }
    }

   ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    if(this.model.doc.cuerpo.cs_id_674 == undefined)this.model.doc.cuerpo.cs_id_674=null;
    if(this.model.doc.cuerpo.cs_id_675 == undefined)this.model.doc.cuerpo.cs_id_675="0";
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if (this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO){this.showSave=true;}
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/descuentos/descuentos-renta-presuntiva-modal/descuentos-renta-presuntiva-modal.component.ts